import { CompanyProtocols } from '../modules/protocols/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { ProtocolsView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

export function CompanyProtocolsScreen({
  view,
  onView,
}: {
  view: ProtocolsView;
  onView: ViewSetter<ProtocolsView>;
}) {
  const { can, timeZone } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('protocols.read')}>
      <CompanyProtocols
        capabilities={{
          canCreate: can('protocols.create'),
          canUpdate: can('protocols.update'),
          canArchive: can('protocols.delete'),
          canReadMaterials: can('protocols.materials.read'),
          canManageMaterials: can('protocols.materials.manage'),
        }}
        timeZone={timeZone}
        view={view}
        onView={onView}
      />
    </GatedCompanyScreen>
  );
}
